/**
 * @author Vaibhav Raut <vaibhav@wemotiveforge.com>
 */

import React from 'react';
import {connect} from 'react-redux';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Button, Input, Modal, Typography } from 'antd';

import {updatePasswordRequest} from '../../AuthenticationApiActions';
import {setPageTitle} from "../../../Dashboard/DashboardActions";
import UtilHelper from "../../../../utils/UtilHelper";
import MessageModal from "../../../../utils/components/MessageModal/MessageModal";
import ConstantMessages from "../../../../utils/Strings";
import {ACTIONS} from '../../../../utils/Constants';
import Auth from '../../../../utils/Auth';
import './ChangePassword.css';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon';
import { LockOutlined } from '@ant-design/icons';

const FormItem = Form.Item;

/**
 * Shown to the user when user clicks on the reset password link in the email
 */
class ChangePasswordForm extends React.Component {

  /**
   * Called when component is mount for the first time
   * Setting page title
   */
  componentDidMount = () => {
    this.props.updatePageTitle(this.props.pageTitle, false);
  };
  /**
   * This method is trigger when form is submitted by the user
   * Validates the form and sends the request to server
   * @param e
   */
  handleSubmit = formData => {
    // e.preventDefault();

    this.setState({submitTrigger: true}, () => {
      // this.props.form.validateFields((err, formData) => {
        // if (!err) {
          this.props.changePassword(formData.newPassword, formData.currentPassword)
            .then((res) => {
              this.refs.messageModal.setState({
                showModal: true, message: ConstantMessages.passwordChangeMessage,
                title: ConstantMessages.passwordChangeTitle,
                showOkButton: true,
                handleOk: this.navigateToLogin,
                okText: 'Ok'

              });
            }, error => {
            });
        // }
      // });
    });
  };
  /**
   * Compare the new password is matching
   * @param rule: rule name
   * @param value: value of the input field which is to be validated
   * @param callback: Method to be called after validation is performed
   */
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('newPassword')) {
      callback('Passwords does not match!');
    } else {
      callback();
    }
  };
  /**
   * Forcefully trigger the validation for the confirmPassword field
   * @param rule: rule name
   * @param value: value of the input field which is to be validated
   * @param callback: Method to be called after validation is performed
   */
  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.submitTrigger) {
      form.validateFields(['confirmPassword'], {force: true});
    }
    callback();
  };
  /**
   * Navigate to the previous page
   */
  navigateBack = () => {
    this.props.history.goBack();
  };
  /**
   * Navigate to the login page on successful password change
   */
  navigateToLogin = () => {
    Auth.logout();
    window.location = ACTIONS.SIGN_IN;
  };

  /**
   * Constructor of Change password
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      submitTrigger: false
    };
  }

  /**
   * Default render method to render the UI components and assign initial value to it
   * @returns {XML}
   */
  render() {
    // const {getFieldDecorator} = this.props.form;

    const fieldValidationRules = {
      currentPassword: {
        rules: [
          {required: true, message: "Please input your current password"},
          {validator: this.validateToNextPassword},
          {validator: UtilHelper.validateBlankSpaces}
        ]
      },
      newPassword: {
        rules: [
          {required: true, message: "Please input your new password"},
          {validator: this.validateToNextPassword},
          {validator: UtilHelper.validateBlankSpaces},
          {validator: UtilHelper.validatePassword}
        ]
      },
      confirmPassword: {
        rules: [
          {required: true, message: "Please re-enter your new password"},
          {validator: this.compareToFirstPassword},
          {validator: UtilHelper.validateBlankSpaces}
        ]
      }
    };

    return (
      <>
      {/* <div className="sivotec-page-content">
        <div className="password-container"> */}
          <Form form={this.props.form} layout="vertical" style={{ width: '100%' }} onFinish={this.handleSubmit}>
            <Form.Item name="currentPassword" label="Current Password" rules={fieldValidationRules.currentPassword.rules}>
              <Input.Password type="password" placeholder="Enter current password" iconRender={(visible) => (visible ? <CustomIcon name="ShowPass" color="#FFF"/> : <CustomIcon name="HidePass" color="#FFF"/>)}/>
            </Form.Item>

            <Form.Item name="newPassword" label="New Password" rules={fieldValidationRules.newPassword.rules}>
              <Input.Password type="password" placeholder="Enter new password" iconRender={(visible) => (visible ? <CustomIcon name="ShowPass" color="#FFF"/> : <CustomIcon name="HidePass" color="#FFF"/>)}/>
            </Form.Item>

            <Form.Item name="confirmPassword" label="Re-enter New Password" rules={fieldValidationRules.confirmPassword.rules}>
              <Input.Password type="password" placeholder="Re-enter new password" iconRender={(visible) => (visible ? <CustomIcon name="ShowPass" color="#FFF"/> : <CustomIcon name="HidePass" color="#FFF"/>)}/>
            </Form.Item>

            <FormItem>
              <Button className="margin-top-2" block type="primary" htmlType="submit">
                Reset Password
                <CustomIcon name="Check" />
              </Button>
            </FormItem>

            <FormItem>
              <Button className="margin-top-2" block onClick={this.props.onCancel}>
                Cancel
                <CustomIcon name="CloseX" />
              </Button>
            </FormItem>

            {/* <Form.Item>
              <Button className="margin-top-2" block htmlType="button" onClick={this.props.onCancel}>
                Cancel
              </Button>
            </Form.Item> */}
          </Form>
        {/* </div>
      </div> */}

      <MessageModal
        ref="messageModal"
      />

      </>
    );
  }
}

let ChangePasswordComponent = (props) => {
  const [form] = Form.useForm();
  return <ChangePasswordForm form={form} {...props} />;
};

let ChangePassword = (props) => {
  const { visible, onCancel, ...rest } = props

  return (
    (<Modal
      open={visible}
      title={
        <div className="flex-horizontal-gap-4">
          <CustomIcon name="LockClosed" width={40} height={40} />
          {/* <LockOutlined style={{ fontSize: '32px' }} /> */}
          <Typography.Title level={2} style={{ margin: 0 }}>Reset Password</Typography.Title>
        </div>
      }
      onCancel={onCancel}
      footer={null}
      width={800}
      bodyStyle={{
        maxHeight: '70vh',
        overflowY: 'auto'
      }}
    >
      <ChangePasswordComponent onCancel={onCancel} {...rest} />
    </Modal>)
  );
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {

    changePassword: (password, currentPassword) => {
      return dispatch(updatePasswordRequest(password, currentPassword)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    updatePageTitle: (pageTitle, enablePageTitle) => {
      dispatch(setPageTitle(pageTitle, enablePageTitle));
    }
  }
};

ChangePassword = connect(
  null,
  mapDispatchToProps
)(ChangePassword);

export default ChangePassword;
